import { __decorate } from "tslib";
import React from 'react';
import { action, flow, isArrayLike, toJS } from 'mobx';
import isPromise from 'is-promise';
import isString from 'lodash/isString';
import noop from 'lodash/noop';
import ValidationResult from './ValidationResult';
import validationRules from './rules';
import valueMissing from './rules/valueMissing';
import { getGlobalConfig } from '../utils';
function* execute(rules, value, props, getProp, validationResults) {
    const method = rules.shift();
    if (method) {
        const results = [];
        const promises = [];
        value.forEach(item => {
            const result = method(item, props, getProp);
            if (isPromise(result)) {
                promises.push(result.then((re) => {
                    results.push(re);
                    return re;
                }));
            }
            else {
                results.push(result);
            }
        });
        if (promises.length) {
            yield Promise.all(promises);
        }
        results.forEach(result => {
            if (result instanceof ValidationResult) {
                validationResults.push(result);
                const index = value.indexOf(result.value);
                if (index !== -1) {
                    value.splice(index, 1);
                }
            }
        });
        if (value.length) {
            for (const result of execute(rules, value, props, getProp, validationResults)) {
                yield result;
            }
        }
    }
}
export default class Validator {
    static reportAll(errors) {
        const { length } = errors;
        if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined' && length > 0) {
            console.warn('validations:', toJS(errors));
        }
    }
    static reportDataSet(errors) {
        const { length } = errors;
        if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined' && length) {
            console.warn('validations:', toJS(errors));
        }
    }
    static async report(results, props) {
        if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined' && results.length) {
            const { name, dataSet, record } = props;
            const reportMessage = [];
            const promises = [];
            results.forEach(({ validationMessage, value }) => {
                promises.push('validation:', isString(validationMessage)
                    ? validationMessage
                    : getGlobalConfig('validationMessageReportFormatter', dataSet && dataSet.getField(name))(React.createElement("span", null, validationMessage)));
                promises.push('\n[value]:', value);
            });
            reportMessage.push(...await Promise.all(promises));
            if (dataSet) {
                const { name: dsName, id } = dataSet;
                if (dsName || id) {
                    reportMessage.push(`
[dataSet<${dsName || id}>]:`, dataSet);
                }
                else {
                    reportMessage.push('\n[dataSet]:', dataSet);
                }
            }
            if (record) {
                if (dataSet) {
                    reportMessage.push(`
[record<${dataSet.indexOf(record)}>]:`, record);
                }
                else {
                    reportMessage.push(`\n[record]:`, record);
                }
            }
            if (name) {
                const field = (record && record.ownerFields.get(name)) || (dataSet && dataSet.getField(name));
                if (field) {
                    reportMessage.push(`
[field<${name}>]:`, field);
                }
                else {
                    reportMessage.push('[field]:', name);
                }
            }
            console.warn(...reportMessage);
        }
    }
    static async checkValidity(value = null, props = {}, getProp = noop) {
        const validationResults = [];
        const valueMiss = valueMissing(value, props, getProp);
        if (valueMiss !== true) {
            validationResults.push(valueMiss);
        }
        else {
            const multiple = getProp('multiple');
            await flow(execute)(validationRules.slice(), multiple && isArrayLike(value) ? value.slice() : [value], props, getProp, validationResults);
        }
        return {
            valid: !validationResults.length,
            validationResults,
            validatorProps: props,
        };
    }
}
__decorate([
    action
], Validator, "checkValidity", null);
